var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1315 -485)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(1315 485)",
    fill: "var(--iconBg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.5 542.5l16.923-20-16.923-20z",
    fill: "none",
    stroke: "var(--iconFg)",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

export default __webpack_public_path__ + "606d468fd439f6422acf9f8a208194ba.svg";
export { SvgPlayIcon as ReactComponent };